module.exports = __webpack_public_path__ + "img/t2.8cd08517.jpg";